export const ADYEN_DROPIN_CONTAINER = "adyen-dropin-container";
export const PAYMENTS_SUMMARY = "payments-summary";
export const PAYMENTS_WEB_COMPONENT = "payments-webcomponent";
export const HOST_CONTAINER = "container";
